import cx from 'classnames';
import { t } from 'i18next';
import { safeCharacterName } from '../../../../../../../shared/common/utils';
import { PossibleStreamTooltip } from '../../../../../../../shared/frontend/components/presentational/streamPreview';
import { Stack } from '../../../../../../../shared/frontend/components/stack/Stack';
import { namedRoutes, resolveRoutePath } from '../../../bundles/routes';
import { Avatar } from '../../../../../../../shared/frontend/components/avatar/Avatar';
import { ClassIcon } from '../../../../../../../shared/frontend/scripts/wow/components/ClassIcon';
import { DataTable } from '../../../../../../../shared/frontend/components/tables/dataTable/DataTable';
import { IDataTableProps, TColumn } from '../../../../../../../shared/frontend/components/tables/types';
import { Link, PossibleLink } from '../../../../../../../shared/frontend/components/link';

type TData = any;

interface ITopILvlCharactersTableProps extends Omit<IDataTableProps<TData>, 'columns'> {}

export const TopILvlCharactersTable = ({ className, ...props }: ITopILvlCharactersTableProps) => {
  return (
    <DataTable hideHeader columns={COLUMNS} className={cx('slds-table rio-rankings-table', className)} {...props} />
  );
};

const COLUMNS: TColumn<TData>[] = [
  {
    accessor: 'character',
    header: 'Character',
    cellRender: ({ data }) => {
      if (!data) {
        return '-';
      }

      return (
        <div className="slds-tile slds-media">
          <Stack alignItems="center" justifyContent="space-between">
            <Avatar border size={24}>
              <ClassIcon class={data.class.slug} size={22} />
            </Avatar>
            <div className="slds-media__body">
              <span
                className={`slds-truncate d-inline-block slds-text-heading--small ${data.stream ? 'streaming-now' : ''} class-color--${data.class.id}`}
              >
                <PossibleStreamTooltip stream={data.stream} hide={data.anonymized}>
                  <PossibleLink
                    allowLink={!data.anonymized}
                    to={resolveRoutePath(namedRoutes.CharacterDetails, {
                      region: data.region.slug,
                      realm: data.realm.slug,
                      character: data.name
                    })}
                    className={'!color-inherit'}
                  >
                    {safeCharacterName(data.name)}
                  </PossibleLink>
                </PossibleStreamTooltip>
              </span>
              <div className="slds-tile__detail slds-text-body--small">
                <Link
                  className="rio-realm-link"
                  to={resolveRoutePath(namedRoutes.RegionHome, { region: data.region.slug })}
                >
                  ({t(`regions:${data.region.slug}.short-name`)})
                </Link>{' '}
                <Link
                  className="rio-realm-link"
                  to={resolveRoutePath(namedRoutes.RealmHome, { region: data.region.slug, realm: data.realm.slug })}
                >
                  {data.realm.name}
                </Link>
              </div>
            </div>
          </Stack>
        </div>
      );
    }
  },
  {
    accessor: 'itemLevelEquipped',
    header: 'Item Level',
    align: 'right',
    width: '80px',
    cellRender: ({ data }) => {
      return (
        <Link
          className="rio-realm-link slds-text-body--large"
          to={resolveRoutePath(namedRoutes.CharacterDetails, {
            region: data.region.slug,
            realm: data.realm.slug,
            character: data.name
          })}
        >
          {data.itemLevelEquipped ? data.itemLevelEquipped.toFixed(2) : '-'}
        </Link>
      );
    }
  }
];
